module.exports = __webpack_public_path__ + "img/reserveForm.950460c0.svg";